import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-dropdown",
  templateUrl: "./dropdown.component.html",
  styleUrls: ["./dropdown.component.scss"],
})
export class DropdownComponent {
  @Input() label: string;
  @Input() dropdownIsOpen = false;

  constructor() {}

  toggleDropdown() {
    this.dropdownIsOpen = !this.dropdownIsOpen;
  }
}
